export const AUTH_PAGE_BANNER_TITLE = 'auth-page.banner-title';
export const AUTH_PAGE_BANNER_ALT = 'auth-page.banner-alt';
